import React, { useMemo } from 'react'
import { Avatar, Tooltip } from 'components/ui'
import acronym from 'utils/acronym'
import PropTypes from 'prop-types'
import useTwColorByName from 'utils/hooks/useTwColorByName'

const UsersAvatarGroup = (props) => {
    const {
        avatarGroupProps,
        avatarProps,
        onAvatarClick,
        users,
        ...rest
    } = props

    const bgColor = useTwColorByName()

    const defaultAvatarProps = useMemo(() => {
        return {
            shape: 'circle',
            size: 30,
            className: 'cursor-pointer',
            ...avatarProps,
        }
    }, [avatarProps])

    const handleAvatarClick = (avatar) => {
        onAvatarClick?.(avatar)
    }

    return (
        <Avatar.Group
            omittedAvatarTooltip
            omittedAvatarProps={defaultAvatarProps}
            chained
            {...avatarGroupProps}
            {...rest}
        >
            {users.map((elm, index) => (
                <Tooltip key={elm?.name + index} title={elm?.name}>
                    <Avatar
                        {...defaultAvatarProps}
                        className={`${
                            elm?.image?.url ? '' : bgColor(elm?.name)
                        } ${defaultAvatarProps.className}`}
                        src={elm?.image?.url}
                        onClick={() => handleAvatarClick(elm)}
                    >
                        {acronym(elm?.name)}
                    </Avatar>
                </Tooltip>
            ))}
        </Avatar.Group>
    )
}

UsersAvatarGroup.defaultProps = {
    avatarProps: {},
    avatarGroupProps: {},
    users: [],
}

UsersAvatarGroup.propTypes = {
    users: PropTypes.array,
    avatarProps: PropTypes.object,
    avatarGroupProps: PropTypes.object,
}

export default UsersAvatarGroup
